import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { v4 as uuid4 } from 'uuid'

interface SnackbarOrigin {
  vertical: 'top' | 'bottom'
  horizontal: 'left' | 'center' | 'right'
}

interface SnackbarOptions {
  key: string
  variant: 'success' | 'error'
  autoHideDuration: number
  anchorOrigin: SnackbarOrigin
}

interface SnackbarQueue {
  message: string
  options: SnackbarOptions
}

interface SnackbarPayload {
  message: string
  options?: Partial<SnackbarOptions>
}

interface SnackbarInitialState {
  snackbarQueue: SnackbarQueue[]
}

const initialState: SnackbarInitialState = {
  snackbarQueue: [],
}

const SnackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action: PayloadAction<SnackbarPayload>) => {
      const { payload } = action

      const {
        key = uuid4(),
        variant = 'error',
        autoHideDuration = 3000,
        anchorOrigin = { vertical: 'top', horizontal: 'center' },
      } = payload?.options || {}

      const snackbarOptions: SnackbarQueue = {
        message: payload.message,
        options: {
          key,
          variant,
          anchorOrigin,
          autoHideDuration,
        },
      }

      state.snackbarQueue.push(snackbarOptions)
    },
    removeSnackbar: (state, action: PayloadAction<string>) => {
      const key = action.payload
      state.snackbarQueue = state.snackbarQueue.filter((snackbar) => snackbar.options.key !== key)
    },
  },
})

export const SnackbarActions = {
  ...SnackbarSlice.actions,
}

export const SnackbarReducer = SnackbarSlice.reducer
